import React, { useContext } from "react";
import { Container } from "react-bootstrap";
import ContentData from "../../../../constants/contentFile.json";
import "./adminActivity.css";
import { AdminActivityContext } from "../AdminActivityView";
import NextIcon from "../../../../assets/images/next-icon.svg";
import { useEffect } from "react";
import PopupAlertError from "../../../../components/PopupAlertError/PopupAlertError";
import Loader from "../../../../components/Loader/Loader";
import BorderButton from "../../../../components/BorderButton/BorderButton";
import ActivityLog from "../../../../components/ActivityLogComponent/ActivityLog";
import ErrorPopup from "../../../../components/PopupAlertError/PopupAlertError";
import InfiniteScroll from "react-infinite-scroll-component";

const AdminActivity = () => {
  const {
    adminActivityListShow,
    adminActivityList,
    spinnerStatus,
    activityPageToList,
    errorPopup,
    setErrorPopup,
    errorPopupMessage,
    buttonText,
    statusValue,
    adminToLogin,
    formatDate,
    formatTime,

    currentPage,
    hasMore,
  } = useContext(AdminActivityContext);

  useEffect(() => {
    const timeoutID = setTimeout(() => {
      adminActivityListShow(currentPage);
    }, 900);

    return () => clearTimeout(timeoutID);
  }, [currentPage]);

  return (
    <div className="pageBg">
      <div className="breadCrums">
        <span className="breadCrumsPointing" onClick={activityPageToList}>
          {ContentData.adminPage.pageTitle}
        </span>
        <img className="nextIcon" src={NextIcon} alt="next icon" />
        <span className="boldBreadCrums">
          {ContentData.rolePermissions.activityRole}
        </span>
      </div>
      {spinnerStatus && <Loader />}
      <Container>
        <div className="pageTittles">
          {ContentData.rolePermissions.activityRole}
        </div>
        <div className="basicContainer adminTable profileInfoContainer ">
          <div className="dataActivityPage">
            <InfiniteScroll
              dataLength={adminActivityList.length} // Total items currently loaded
              next={() => adminActivityListShow(currentPage + 1)} // Load more data
              hasMore={hasMore} // Indicates if more data exists
              loader={<div className="loadingIndicator">Loading...</div>} // Loader
              endMessage={
                <p style={{ textAlign: "center" }}>No more activity logs</p>
              }
            >
              {adminActivityList.map((item, index) => (
                <ActivityLog
                  key={index}
                  name={item?.name || "-"}
                  date={item?.createdAt ? formatDate(item.createdAt) : "-"}
                  time={item?.createdAt ? formatTime(item.createdAt) : "-"}
                  activityMessage={item?.description || "-"}
                />
              ))}
            </InfiniteScroll>
          </div>
        </div>
      </Container>
      <ErrorPopup
        show={errorPopup}
        alertMessage={errorPopupMessage}
        buttonText={buttonText}
        status={statusValue}
        handleCancel={() => {
          activityPageToList();
          setErrorPopup(false);
        }}
        handleSubmit={() => {
          if (statusValue === 401 || statusValue === 403) {
            adminToLogin();
            setErrorPopup(false);
          } else {
            setErrorPopup(false);
            adminActivityListShow(currentPage);
          }
        }}
      />
    </div>
  );
};

export default AdminActivity;
